module.exports = __webpack_public_path__ + "d96f2a08316139ab62ec8cc358509847.png";